import currencyFormatter from "currency-formatter";
export const dispatchMountEvent = (name = "") => {
  document.dispatchEvent(new CustomEvent("svelte.mounted", { detail: name }));
};
export const dispatchRenderEvent = (name = "") => {
  document.dispatchEvent(new CustomEvent("svelte.rendered", { detail: name }));
};
export const toCurrency = (value, precision = 2) => {
  if (value == "" || isNaN(value)) {
    return "";
  }
  return currencyFormatter.format(value, {
    code: "GBP",
    symbol: "£",
    precision,
  });
};

export const toPriceCurrency = (value, precision = 2) => {
  if (value == "" || isNaN(value)) {
    return "";
  }
  return currencyFormatter.format(value, {
    precision,
  });
};

export const isValidFileType = (file, accept) => {
  if (accept) {
    const regexString = accept
      .replace("*", ".*")
      .split(",")
      .join("|")
      .replace(/\s/g, "");
    if (
      new RegExp(regexString).test(file.type) ||
      new RegExp(regexString + "$", "i").test(file.name)
    ) {
      return true;
    }
    return false;
  }
  return true;
};

export const compareCSVHeaders = (
  rawHeaders: string[],
  compareHeaders: { name: string; required: boolean }[]
): string[] => {
  return compareHeaders
    .filter(
      (header) =>
        header.required &&
        rawHeaders.findIndex(
          (h) => h.toLowerCase() === header.name.toLowerCase()
        ) === -1
    )
    .map((h) => h.name);
};

export const getCSVColumnIndex = (
  rawHeaders: string[],
  compareHeaders: { name: string; required: boolean }[]
): number[] => {
  return compareHeaders
    .map((header) =>
      rawHeaders.findIndex((h) => h.toLowerCase() === header.name.toLowerCase())
    )
    .filter((i) => i !== -1);
};

export const getCSVDisplayableHeaders = (
  rawHeaders: string[],
  compareHeaders: { name: string; required: boolean }[]
): { name: string; required: boolean }[] => {
  return compareHeaders.filter(
    (header) =>
      rawHeaders.findIndex(
        (h) => h.toLowerCase() === header.name.toLowerCase()
      ) !== -1
  );
};
  export const standardDocumentType =
  "text/xml, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, text/rtf, text/richtext, application/rtf, application/pdf, image/*, .rtf, .csv";
